import type { UseMutationOptions, UseQueryResult } from "@tanstack/react-query";
import type { Loadable } from "./loadable";

type FuncHasQueryOptions = (
  // biome-ignore lint: any型を指定しないと4つの型を全てgenericsにしないといけないが、部分的に型を抽出したいだけなのでそこまでは必要ない
  params: any,
  // biome-ignore lint: 同様
  options: any,
  // biome-ignore lint: 同様
) => any;

type FuncHasMutationOptions = (options?: {
  // biome-ignore lint: any型を指定しないと4つの型を全てgenericsにしないといけないが、部分的に型を抽出したいだけなのでそこまでは必要ない
  mutation?: UseMutationOptions<any, any, any, any>;
  // biome-ignore lint: 同様
}) => any;

export type QueryOptions<T extends FuncHasQueryOptions> = NonNullable<
  NonNullable<Parameters<T>[1]>["query"]
>;

export type MutationOptions<T extends FuncHasMutationOptions> = NonNullable<
  NonNullable<Parameters<T>[0]>["mutation"]
>;

export type ExtractMutationVariables<T> = T extends {
  onMutate?: (variables: infer TVariables) => unknown;
}
  ? TVariables
  : never;

export type MutationVariables<T extends FuncHasMutationOptions> =
  ExtractMutationVariables<MutationOptions<T>>;

export const loadableFromUseQueryResult = <TData, TError>(result: {
  data: UseQueryResult<TData, TError>["data"];
  status: UseQueryResult<TData, TError>["status"];
  error: UseQueryResult<TData, TError>["error"];
}): Loadable<TData, { message: string }> => {
  if (result.status === "pending") {
    return { status: "loading" };
  }
  if (result.error || !result.data) {
    return {
      status: "error",
      error: { message: JSON.stringify(result.error) },
    };
  }
  return { status: "success", data: result.data };
};

export const multipleUserQueryResultsCompleted = <TData, TError>(
  params: Record<string | number, unknown>,
  result: Record<string | number, UseQueryResult<TData, TError>>,
): boolean => {
  if (Object.values(params).length !== Object.values(result).length) {
    return false;
  }
  return Object.values(result).every((r) => r.status === "success");
};
